import { useEffect } from 'react'

export const ClearSensorFaultsResult = ({ setShowCommandModal }) => {
  useEffect(() => setShowCommandModal(false), [setShowCommandModal])
  return null
}
